import * as React from "react"

interface IProps {
  className?: string
}

export default function Play({ className }: IProps) {
  return (
    <svg
      height="500"
      viewBox="0 0 500 500"
      width="500"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m478.409978 235.509653-407.739696-212.7793002c-10.6898048-5.3385488-23.670282 2.2879494-23.670282 14.4903466v425.5586016c0 12.202397 12.9804772 19.828895 23.670282 14.490346l407.739696-212.7793c11.453363-6.101199 11.453363-22.879495 0-28.980694z"
        fill="currentColor"
      />
    </svg>
  )
}
